// The Try Now white-label storefront: a neutral blue-grey palette, no client branding. Same token names as
// tailwind.config.tuuleliinid.js, because the trial theme renders the TL booking flow. neutral, success, warning,
// error and info keep the TL values (plain greys and status colours). primary-base on white is 7.1:1, interactive on
// white (and white on interactive) 5.2:1.
module.exports = {
  colors: {
    'base-darkest': '#0F1E33',
    'base-darker': '#17304F',
    'base-dark': '#1F426B',
    'primary-base': '#2B5A8C',
    interactive: '#2F6FB0',
    'base-medium-light': '#2F6FB0',
    'base-medium-lighter': '#5A8CC2',
    'base-normal-light': '#85A9D3',
    'base-normal-lighter': '#B0C6E3',
    'base-very-light': '#D8E3F1',
    'base-lightest': '#EEF3F9',
    'base-muted': '#7F8FA3',

    'secondary-darkest': '#1A1F26',
    'secondary-darker': '#2E3640',
    'secondary-dark': '#434E5B',
    secondary: '#596776',
    'secondary-medium-light': '#738192',
    'secondary-medium-lighter': '#8E9AA9',
    'secondary-normal-light': '#A9B3BF',
    'secondary-normal-lighter': '#C6CDD5',
    'secondary-very-light': '#E2E6EA',
    'secondary-lightest': '#F1F3F5',

    'tertiary-darkest': '#1C1D20',
    'tertiary-darker': '#33353A',
    'tertiary-dark': '#4B4E55',
    tertiary: '#636770',
    'tertiary-medium-light': '#7D818B',
    'tertiary-medium-lighter': '#979BA4',
    'tertiary-normal-light': '#B2B5BC',
    'tertiary-normal-lighter': '#CDCFD4',
    'tertiary-very-light': '#E7E8EB',
    'tertiary-lightest': '#F3F4F5',

    'complimentary-darkest': '#142231',
    'complimentary-darker': '#24405C',
    'complimentary-dark': '#355E87',
    complimentary: '#4A7AA8',
    'complimentary-medium-light': '#6890B8',
    'complimentary-medium-lighter': '#86A6C8',
    'complimentary-normal-light': '#A5BDD7',
    'complimentary-normal-lighter': '#C3D3E6',
    'complimentary-very-light': '#E1E9F2',
    'complimentary-lightest': '#F0F4F9',

    'accent-darkest': '#1B1F33',
    'accent-darker': '#30375C',
    'accent-dark': '#465085',
    accent: '#5C69A8',
    'accent-medium-light': '#7782B8',
    'accent-medium-lighter': '#939CC8',
    'accent-normal-light': '#AFB5D7',
    'accent-normal-lighter': '#CBCFE6',
    'accent-very-light': '#E5E7F2',
    'accent-lightest': '#F2F3F9',

    'neutral-darkest': '#1C1C1C',
    'card-title': '#1C1C1C',
    'card-desc': '#393939',
    'card-label': '#393939',
    'card-value': '#A5A5A5',
    'card-quantity': '#393939',
    'card-subtotal': '#A5A5A5',
    'neutral-darker': '#393939',
    'neutral-dark': '#555555',
    neutral: '#727272',
    'neutral-medium-light': '#8E8E8E',
    'neutral-medium-lighter': '#A5A5A5',
    'neutral-normal-light': '#BBBBBB',
    'neutral-normal-lighter': '#D2D2D2',
    'neutral-very-light': '#E8E8E8',
    'neutral-lightest': '#F4F4F4',
    'neutral-ultra-lightest': '#FAFAFA',
    'neutral-background-profile': '#FAFAFA',

    'success-darkest': '#0E260E',
    'success-darker': '#1B4C1B',
    'success-dark': '#297329',
    success: '#369936',
    'success-medium-light': '#44BF44',
    'success-medium-lighter': '#69CC69',
    'success-normal-light': '#8FD98F',
    'success-normal-lighter': '#B4E5B4',
    'success-very-light': '#DAF2DA',
    'success-lightest': '#EDF9ED',

    'warning-darkest': '#332B05',
    'warning-darker': '#665709',
    'warning-dark': '#99820E',
    warning: '#CCAE12',
    'warning-medium-light': '#FFD917',
    'warning-medium-lighter': '#FFE145',
    'warning-normal-light': '#FFE874',
    'warning-normal-lighter': '#FFF0A2',
    'warning-very-light': '#FFF7D1',
    'warning-lightest': '#FFF3E8',

    'error-darkest': '#2D0A06',
    'error-darker': '#5A140C',
    'error-dark': '#861D11',
    error: '#B32717',
    'error-medium-light': '#E0311D',
    'error-medium-lighter': '#E65A4A',
    'error-normal-light': '#EC8377',
    'error-normal-lighter': '#F3ADA5',
    'error-very-light': '#F9D6D2',
    'error-lightest': '#FCEBE9',

    'frozen-ice': '#28B5F3',
    hazard: '#FF5A19',
    'alert-dark': '#B42A2A',
    'alert-base': '#D0021B',
    'alert-lightest': '#FFF6F6',

    'info-darkest': '#082431',
    'info-darker': '#104861',
    'info-dark': '#186D92',
    info: '#2091C2',
    'info-medium-light': '#28B5F3',
    'info-medium-lighter': '#53C4F5',
    'info-normal-light': '#7ED3F8',
    'info-normal-lighter': '#A9E1FA',
    'info-very-light': '#D4F0FD',

    // The trial vehicle card (modules/trial/SelectTicketPage, the same names as tailwind.config.kihnu.js) in the trial palette.
    // text-muted on white is 7.0:1, text-label on white 5.8:1.
    'base-medium-light-hover': '#255C94',
    'base-disabled': '#A9BCD3',
    'text-muted': '#4A5A6E',
    'text-label': '#56677D',
    'border-success': '#369936',
    'border-line': '#C6D2E0',
    'border-line-strong': '#AFC2D8',
    'surface-tile': '#F5F8FC',
    'surface-tile-hover': '#EAF0F7',
    'surface-danger': '#FCEBE9',
    'border-danger-hover': '#EC8377',
  },
  extend: {
    boxShadow: {
      card: '0 2px 8px rgba(15,30,51,.10)',
      dropdown: '0 12px 28px rgba(15,30,51,.16)',
      'cta-blue': '0 3px 10px rgba(47,111,176,.22)',
      'cta-blue-hover': '0 6px 16px rgba(15,30,51,.24)',
    },
  },
  backgroundPosition: {
    '20-center': '20% center',
  },
  backgroundSize: {
    cover: 'cover',
  },
  backgroundRepeat: {
    'no-repeat': 'no-repeat',
  },
  backgroundAttachment: {
    fixed: 'fixed',
  },
}
